import { Tabs } from "antd";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import ShopMap from "./ShopMap";
import ListShopCabinetManage from "./pages/list";
import mapApi from "api/map";

const cx = classNames.bind(style);

export default function MapPage() {
  const [selectedTab, setSelectedTab] = useState("1");
  const [listShop, setListShop] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listCabinet, setListCabinet] = useState([]);

  const { t } = useTranslation()

  const getAllCabinet = async () => {
    try {
      setLoading(true)
      const res = await mapApi.getAllCabinet();
      setListCabinet(res.data);
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }

  const getAllShop = async () => {
    try {
      setLoading(true)
      const res = await mapApi.getAllShop();
      setListShop(res.data);
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }


  const items = [
    {
      key: '1',
      label: t('map'),
      children: <ShopMap listShop={listShop} listCabinet={listCabinet} loading={loading} />,
    },
    {
      key: '2',
      label: t('list'),
      children: <ListShopCabinetManage
        getAllCabinet={getAllCabinet}
        getAllShop={getAllShop}
        listShop={listShop}
        listCabinet={listCabinet}
        loading={loading}
        setLoading={setLoading}
      />,
    },
  ];

  const onChange = (key) => {
    setSelectedTab(key);
  };

  useEffect(() => {
    getAllShop();
    getAllCabinet();
  }, []);

  return (
    <div className={cx("page-shop")}>
      <div className={cx("title")}>
        <p>{t('map')}</p>
      </div>
      <Tabs type="card" activeKey={selectedTab} items={items} onChange={onChange} />
    </div>
  );
}
